import { Image } from "react-bootstrap";

export function Cargando() {

    return <div style={
        {
            width: '100%',
            minHeight: '100vh',
            zIndex: 10,
            position: 'fixed',
            top:0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(255,255,255,0.1)'
        }}>
        <Image src={process.env.PUBLIC_URL+'/cargando.gif'} style={{/*flex: 'auto',*/ width: 100 +'px', verticalAlign: 'middle'}} />
    </div>;

}